<template>
    <el-dialog :title="titleDialog" :visible="showDialog" @close="close" @open="create" width="600px">
        <form autocomplete="off" @submit.prevent="submit">
            <div class="form-body">
                <div class="row">
                    <!-- Nombre de la variable -->
                    <div class="col-md-12">
                        <div class="form-group" :class="{'has-danger': errors.name}">
                            <label class="control-label">Nombre de la variable</label>
                            <el-input v-model="form.name" placeholder="Ej: Color, Talla de ropa"></el-input>
                            <small class="form-control-feedback" v-if="errors.name" v-text="errors.name[0]"></small>
                        </div>
                    </div>
                    <!-- Valores de la variable -->
                    <div class="col-md-12">
                        <div class="form-group" :class="{'has-danger': errors.values}">
                            <label class="control-label">Valores de la variable</label>
                            <el-input v-model="new_value"
                                      placeholder="Ej: Rojo, L"
                                      @keydown.enter.native.prevent="addValue">
                                <el-button slot="append" icon="el-icon-plus" @click.prevent="addValue">Agregar</el-button>
                            </el-input>
                            <small class="form-control-feedback" v-if="errors.values" v-text="errors.values[0]"></small>
                        </div>
                        <div class="d-flex flex-wrap">
                            <div v-for="(row, index) in form.values"
                                 :key="index"
                                 class="attribute-value-chip mr-2 mb-2">
                                <el-color-picker v-if="isColorAttribute"
                                                 v-model="row.color"
                                                 :predefine="predefinedColors"
                                                 size="mini"></el-color-picker>
                                <span class="mx-1">{{ row.value }}</span>
                                <i class="el-icon-close attribute-value-remove"
                                   @click="form.values.splice(index, 1)"></i>
                            </div>
                        </div>
                        <small v-if="isColorAttribute" class="text-muted d-block">
                            Los colores conocidos (Rojo, Azul, Negro...) se asignan solos. Haz clic en el círculo para cambiar la tonalidad.
                        </small>
                    </div>
                    <div class="col-md-12 mt-2">
                        <el-checkbox v-model="form.show_name_in_description">
                            Mostrar el nombre de la variable en la descripción de la variación (ej: "TALLA DE ROPA L")
                        </el-checkbox>
                    </div>
                </div>
            </div>
            <div class="form-actions text-right pt-2">
                <el-button @click.prevent="close()">Cancelar</el-button>
                <el-button type="primary" native-type="submit" :loading="loading_submit">Guardar</el-button>
            </div>
        </form>
    </el-dialog>
</template>

<script>

    import {suggestColor, PREDEFINED_COLORS} from '@helpers/attribute_colors'

    export default {
        props: ['showDialog', 'recordId'],
        data() {
            return {
                loading_submit: false,
                titleDialog: null,
                resource: 'product-attributes',
                errors: {},
                form: {},
                new_value: null,
                predefinedColors: PREDEFINED_COLORS,
            }
        },
        computed: {
            isColorAttribute() {
                // es una variable de color si su nombre lo dice o si alguno de sus valores ya tiene color
                return /color/i.test(this.form.name || '') || (this.form.values || []).some(row => row.color)
            },
        },
        created() {
            this.initForm()
        },
        methods: {
            initForm() {
                this.errors = {}
                this.new_value = null

                this.form = {
                    id: null,
                    name: null,
                    show_name_in_description: false,
                    values: [],
                }
            },
            create() {

                this.titleDialog = (this.recordId)? 'Editar atributo':'Nuevo atributo'
                if (this.recordId) {
                    this.$http.get(`/${this.resource}/record/${this.recordId}`).then(response => {
                            const form = response.data
                            // a los valores sin color se les sugiere uno según su nombre; se guarda al pulsar Guardar
                            form.values = form.values.map(row => Object.assign({}, row, {
                                color: row.color || suggestColor(row.value),
                            }))
                            this.form = form
                        })
                }
            },
            addValue() {
                const value = (this.new_value || '').trim()
                if (!value) return

                const exists = this.form.values.some(row => row.value.toUpperCase() === value.toUpperCase())
                if (exists) return this.$message.warning('El valor ya fue agregado')

                this.form.values.push({id: null, value: value, color: suggestColor(value)})
                this.new_value = null
            },
            submit() {

                if (this.form.values.length === 0) return this.$message.error('Debe agregar al menos un valor')

                this.loading_submit = true
                this.$http.post(`${this.resource}`, this.form)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                            this.$eventHub.$emit('reloadData')
                            this.close()
                        } else {
                            this.$message.error(response.data.message)
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.errors = error.response.data
                        } else {
                            console.log(error.response)
                        }
                    })
                    .then(() => {
                        this.loading_submit = false
                    })

            },
            close() {
                this.$emit('update:showDialog', false)
                this.initForm()
            }
        }
    }
</script>

<style scoped>
.attribute-value-chip {
    display: inline-flex;
    align-items: center;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 2px 8px;
}

.attribute-value-remove {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// modules/Item/Resources/assets/js/views/product-attributes/form.vue